<div *ngIf="parentGroup && parentGroup.controls.location" [formGroup]="location">
<div>
    <div class="m-portlet" style="width: 100%">

        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">
                        {{ formName ? formName : 'LOCATION' }}
                    </h3>
                    <span (click)="openLocationInfo()" class="info-header-icon m-portlet__head-text">
                        <img
                            src="../../assets/app/media/img/icons/info-icon.png"
                            class="tooltip-icon"
                            style="position: relative; cursor: pointer;"
                            tooltip="Click here for more information about Station Operators"
                            />
                    </span>
                </div>
            </div>
        </div>

        <div class="m-portlet__body">

            <div class="m-form__section m-form__section--first">

                  <div *ngIf="!disableSelection" class="form-group m-form__group row">
                    <label class="col-lg-4 col-form-label">
                    </label>
                    <div class="col-lg-3">
                        <select
                            formControlName="locationId"
                            class="col-lg-12 col-m-4 form-control m-input"
                            id="locationId"
                            name="locationIdSelect"
                            (change)="selectLocation($event.target.value)"
                            >
                            <option selected value="-1">-- Create New Location --</option>
                            <option
                                *ngFor="let l of locations"
                                [selected]="l.locationId == location.controls.locationId.value"
                                [value]="l.locationId"
                            >
                                {{ l.name }}
                            </option>
                            </select>
                            <span class="m-form__help">Choose an existing location, or create a new one. </span>
                            <span style="font-weight: 800;" class="m-form__help">This must be a valid US address. </span>
                            <app-validation-display
                                [control]="location.controls.locationId"
                                errorMessage="Please choose or create a location"
                            ></app-validation-display>
                    </div>
                </div>

                    <div class="form-group m-form__group row">
                        <label class="col-lg-4 col-form-label">
                            Location Name:
                            <span [hidden]="location.controls.name.value" class="required-asterisk text-danger">*</span>
                        </label>
                        <div class="col-lg-3">
                        <input
                            formControlName="name"
                            type="text"
                            id="name"
                            class="form-control m-input"
                            placeholder=""
                            maxlength="40"
                        />
                        <app-validation-display
                            [control]="location.controls.name"
                            errorMessage="Please choose a customer facing name for this location"
                        ></app-validation-display>
                        </div>
                    </div>

                    <div class="form-group m-form__group row">
                        <label class="col-lg-4 col-form-label">
                            Time Zone:
                            <span [hidden]="location.controls.timeZone.value" class="required-asterisk text-danger">*</span>
                        </label>
                        <div class="col-form-label pl-md-4 ml-2" *ngIf="locationFormControls('locationId').value !== -1">
                            <label>
                             {{location.controls.timeZone.value}}
                            </label>
                        </div>
                        <div class="col-lg-3" *ngIf="timeZones && locationFormControls('locationId').value == -1">
                            <select
                                class="form-control m-input"
                                id="timeZones"
                                formControlName="timeZone"
                                [compareWith]="compare"
                                name="timeZones">
                            <option disabled value="0">--- Select Timezone ---</option>
                            <option *ngFor="let z of timeZones.us" [ngValue]="z.Id">
                                {{z.DisplayName}}
                            </option>
                          </select>

                          <app-validation-display
                            [control]="location.controls.timeZone"
                            errorMessage="Please select a valid time zone for this location"
                          ></app-validation-display>
                        </div>
                    </div>

                <div formGroupName="address">
                    <div class="form-group m-form__group row">
                        <label class="col-lg-4 col-form-label">
                            Address Line 1:
                            <span [hidden]="location.controls.address.controls.addressLine1.value" class="required-asterisk text-danger">*</span>
                        </label>
                        <div class="col-lg-3">
                        <input
                            maxlength="60"
                            formControlName="addressLine1"
                            type="text"
                            id="name"
                            class="form-control m-input"
                            placeholder=""
                        />
                        <app-validation-display
                            [control]="location.controls.address.controls.addressLine1"
                            errorMessage="Please specify line one of the location's address"
                        ></app-validation-display>
                        </div>
                    </div>

                    <div class="form-group m-form__group row">
                        <label class="col-lg-4 col-form-label">
                            Address Line 2:
                        </label>
                        <div class="col-lg-3">
                        <input
                            maxlength="60"
                            formControlName="addressLine2"
                            type="text"
                            id="name"
                            class="form-control m-input"
                            placeholder=""
                        />
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <label class="col-lg-4 col-form-label">
                            City:
                            <span [hidden]="location.controls.address.controls.city.value" class="required-asterisk text-danger">*</span>
                        </label>
                        <div class="col-lg-3">
                        <input
                            maxlength="60"
                            formControlName="city"
                            type="text"
                            id="name"
                            class="form-control m-input"
                            placeholder=""
                        />
                        <app-validation-display
                            [control]="location.controls.address.controls.city"
                            errorMessage="Please specify the city"
                        ></app-validation-display>
                        </div>
                    </div>

                    <div class="form-group m-form__group row ">
                        <label class="col-lg-4 col-form-label">
                        State:
                          <span [hidden]="location.controls.address.controls.stateProvince.value" class="required-asterisk text-danger">*</span>
                        </label>
                        <div *ngIf="locationFormControls('locationId').value == -1" class="col-lg-3">
                            <select
                                formControlName="stateProvince"
                                class="col-lg-12 col-m-4 form-control m-input"
                                id="stateProvince"
                                name="stateProvinceSelect"
                                >
                                <option selected value="0">-- Select State --</option>
                                <option
                                    *ngFor="let s of states"
                                    [selected]="s == location.controls.address.controls.stateProvince.value"
                                    [value]="s"
                                >
                                    {{ statesPairs[s] }}
                                </option>
                                </select>
                                <app-validation-display
                                    [control]="location.controls.address.controls.stateProvince"
                                    errorMessage="Please specify the state"
                                ></app-validation-display>
                        </div>
                        <div *ngIf="locationFormControls('locationId').value !== -1" class="col-form-label pl-xl-4 col-lg-3 ml-2">
                          <label>
                            {{getUSState(location.controls.address.controls.stateProvince.value)}}
                          </label>
                        </div>
                    </div>

                    <div class="form-group m-form__group row">
                        <label class="col-lg-4 col-form-label">
                            Postal Code:
                            <span [hidden]="location.controls.address.controls.postalCode.value" class="required-asterisk text-danger">*</span>
                        </label>
                        <div class="col-lg-3">
                        <input
                            formControlName="postalCode"
                            type="text"
                            id="name"
                            [ignoreWhiteSpace]
                            pattern="^\d{5}(?:[-\s]\d{4})?\s?$"
                            class="form-control m-input"
                            placeholder=""
                            maxlength="12"
                        />
                        <app-validation-display
                            [control]="location.controls.address.controls.postalCode"
                            errorMessage="Please specify a correct postal code"
                        ></app-validation-display>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
